import { TelemetryClient } from '@micro-frontend-react/employee-experience/lib/TelemetryClient';
import { HttpClient } from '@micro-frontend-react/employee-experience/lib/HttpClient';
import { GraphClient } from '@micro-frontend-react/employee-experience/lib/GraphClient';
import { Shell } from '@micro-frontend-react/employee-experience/lib/Shell';
import { withStore } from '@micro-frontend-react/employee-experience/lib/withStore';
import { StoreBuilder } from '@micro-frontend-react/employee-experience/lib/StoreBuilder';
import { ReducerRegistry } from '@micro-frontend-react/employee-experience/lib/ReducerRegistry';
import { UsageHelper, UserAttribute } from '@micro-frontend-react/employee-experience/lib/UsageTelemetry';
import { ITelemetryContext } from '@micro-frontend-react/employee-experience/lib/ITelemetryContext';
import { AuthClient } from './Environments/AuthClient';


export const telemetryClient = new TelemetryClient({
  instrumentationKey: __INSTRUMENTATION_KEY__,
  UTPConfig: __UTP_CONFIG__,
  defaultProperties: {
    appName: __APP_NAME__,
  },
});
const authClient = new AuthClient(
  {
    auth: {
      clientId: __CLIENT_ID__,
      redirectUri: window.location.origin,
      authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47',
    },
  },
  telemetryClient
);
const usageHelper = __APP_NAME__ && __APP_NAME__.trim() != '' ? UsageHelper.Fork(__APP_NAME__) : UsageHelper;

const telemetryContext: ITelemetryContext = {
  sourceComponent: 'Shell',
  sourceScript: 'main',
  setUsageEvent: usageHelper.MassageEvent,
  setUsageUser: (usageUser: UserAttribute) => {
    UsageHelper.SetUser(usageUser);
    usageHelper.SetUser(usageUser);
    return usageUser;
  },
  usageUser: usageHelper.GetUser,
  setUsageConfig: usageHelper.SetUsageConfig,
  getChildContext: usageHelper.ForkTelemetryContext,
};

telemetryClient.setContext(telemetryContext);
const httpClient =
  __IS_ACCESSIBILITY_TESTING__ === false
    ? new HttpClient(telemetryClient, authClient)
    : new HttpClient(telemetryClient, undefined);
const graphClient = new GraphClient(httpClient);
const reducerRegistry = new ReducerRegistry();
const appName = 'Voluntary Separation Tool';
const storeResult = new StoreBuilder(reducerRegistry, {})
  .configureLogger(__IS_DEVELOPMENT__)
   .configureSaga({telemetryContext, appName, httpClient, graphClient, telemetryClient, authClient})
  .build();

export const ShellWithStore = withStore(storeResult)(Shell);
